import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  type EnumMenuOutboundItemsKey,
  listItemsOutbound,
  OutboundKey,
} from 'widgets/Menu/ui/MenuOutbound/constants/menuItems'

export const getStateAccessOutbound = (key: EnumMenuOutboundItemsKey, entities: IEntitiesStore) => {
  if (entities.subscriptionStore.isAgencyWithoutSubscription) return false

  switch (key) {
    case 'broadcasts_all':
    case 'broadcasts_onetime':
    case 'broadcasts_recurring':
      return checkAccessPage(EnumAccessPageKeys.broadcasts, entities)
    case 'triggers_all':
    case 'triggers_sms':
    case 'triggers_ringless':
    case 'triggers_rcs':
      return checkAccessPage(EnumAccessPageKeys.triggers, entities)
    case 'power_dialer':
      return checkAccessPage(EnumAccessPageKeys.power_dialer, entities)
    default:
      return true
  }
}

const accessList = (entities: IEntitiesStore) => {
  return Object.entries(listItemsOutbound).reduce<string[]>((state, [id, path]) => {
    const key = id as EnumMenuOutboundItemsKey

    if (getStateAccessOutbound(key, entities)) state.push(path)

    return state
  }, [])
}

export const getPath = (path: string | null, entities: IEntitiesStore) => {
  const list = accessList(entities)

  if (!list.length) return ''
  if (!path) return list[0]
  if (!list.includes(path)) return list[0]

  return path
}

export const getPathOutbound = (userId: number, entities: IEntitiesStore) => {
  let path = window.localStorage.getItem(`${userId}_menu_${OutboundKey}`)

  path = getPath(path, entities)

  if (path && path[0] === '/') {
    path = path.slice(1)
  }

  return path
}
